import { FormlyFieldConfig } from '@ngx-formly/core';
import { FORMLY_FIELD_TYPES, FORMLY_FIELD_VALIDATORS, FORMLY_FIELD_WRAPPERS } from '@app/constants';
import { UnitSetupConfig } from './unit-setup-config.interface';

export const unitTabFields = (config: UnitSetupConfig): FormlyFieldConfig[] => {
	return [
		{
			wrappers: [FORMLY_FIELD_WRAPPERS.customWrapper],
			fieldGroup: [
				{
					type: FORMLY_FIELD_TYPES.headerLabel,
					props: {
						label: 'Unit Configuration',
						useElementH: '5',
						useSecondaryColor: true,
						horizontalLine: true,
						bold: true,
						useDefaultLineColor: true,
						marginBottom: 4,
					},
				},
				{
					fieldGroupClassName: 'row',
					fieldGroup: [
						{
							key: 'PendoProfile',
							type: FORMLY_FIELD_TYPES.select,
							className: 'col-md-3',
							props: {
								label: 'Pendo Profile',
								required: true,
							},
							expressions: {
								'props.options': 'formState.selects.pendoProfiles',
								'props.disabled': () => !config.isGA || config.isReadOnly,
							},
						},
						{
							key: 'ACHSetupId',
							type: FORMLY_FIELD_TYPES.select,
							className: 'col-md-3',
							props: {
								label: 'ACH Setup',
								required: true,
							},
							expressions: {
								'props.options': 'formState.selects.achSetupArray',
								'props.disabled': () => !config.isGA || config.isReadOnly,
							},
						},
						{
							fieldGroupClassName: 'col-md-2 cb-container',
							fieldGroup: [
								{
									className: 'cb-default',
									key: 'UseNetAccounts',
									type: FORMLY_FIELD_TYPES.checkbox,
									props: {
										label: 'Use Net Accounts',
										appearance: 'fill',
										indeterminate: false,
									},
									expressions: {
										'props.disabled': () => config.isReadOnly,
									},
								},
							],
						},
						{
							fieldGroupClassName: 'col-md-2 cb-container',
							fieldGroup: [
								{
									key: 'SiteAccounting',
									type: FORMLY_FIELD_TYPES.checkbox,
									className: 'cb-default',
									props: {
										label: 'Site Accounting',
										appearance: 'fill',
										indeterminate: false,
										disabled: config.isReadOnly,
									},
								},
								{
									type: FORMLY_FIELD_TYPES.tooltip,
									props: {
										label: `When "Site Accounting" is enabled, site-level setup is activated for Purchase Order Setup.`,
									},
								},
							],
						},
					],
				},
				{
					fieldGroupClassName: 'row',
					fieldGroup: [
						{
							fieldGroupClassName: 'col-md-3 cb-container',
							fieldGroup: [
								{
									className: 'cb-default cb-extended',
									key: 'IncludeHeaderOnExcelExports',
									type: FORMLY_FIELD_TYPES.checkbox,
									props: {
										label: 'Include Report Header On Excel Exports',
										appearance: 'fill',
										indeterminate: false,
									},
									expressions: {
										'props.disabled': () => config.isReadOnly,
									},
								},
							],
						},
					],
				},
			],
		},
		{
			wrappers: [FORMLY_FIELD_WRAPPERS.customWrapper],
			fieldGroup: [
				{
					type: FORMLY_FIELD_TYPES.headerLabel,
					props: {
						label: 'Hub Integration',
						useElementH: '5',
						useSecondaryColor: true,
						horizontalLine: true,
						bold: true,
						useDefaultLineColor: true,
						marginBottom: 4,
					},
				},
				{
					fieldGroupClassName: 'row',
					fieldGroup: [
						{
							key: 'EventHubDistrictId',
							type: FORMLY_FIELD_TYPES.input,
							className: 'col-md-3',
							props: {
								label: 'Hub District Id',
								readonly: true,
							},
						},
						{
							key: 'EventHubCustomerId',
							type: FORMLY_FIELD_TYPES.select,
							className: 'col-md-3',
							props: {
								label: 'Hub Customer',
							},
							expressions: {
								'props.options': 'formState.selects.customers',
								'props.disabled': () => config.isReadOnly || !config.isGA,
							},
						},
						{
							type: FORMLY_FIELD_TYPES.formlyMatButton,
							props: {
								matButtonName: 'mat-button',
								class: '',
								label: 'Create Event Hub Customer',
								icon: 'add',
								color: 'primary',
								onClick: () => config.createEventHubCustomer?.(),
							},
							expressions: {
								hide: () => config.isReadOnly || !config.isGA,
							},
						},
					],
				},
			],
		},
		{
			wrappers: [FORMLY_FIELD_WRAPPERS.customWrapper],
			fieldGroup: [
				{
					type: FORMLY_FIELD_TYPES.headerLabel,
					props: {
						label: 'Ledger and Invoice Configuration',
						useElementH: '5',
						useSecondaryColor: true,
						horizontalLine: true,
						bold: true,
						useDefaultLineColor: true,
						marginBottom: 4,
					},
				},
				{
					fieldGroupClassName: 'row',
					fieldGroup: [
						{
							key: 'NextRefNumber',
							type: FORMLY_FIELD_TYPES.inputPositiveIntegers,
							className: 'col-md-3',
							props: {
								label: 'Journal Entry Starting Ref #',
								required: false,
								maxLength: 9,
								readonly: config.isReadOnly,
							},
						},
						{
							key: 'VendorCodePrefix',
							type: FORMLY_FIELD_TYPES.input,
							className: 'col-md-3',
							props: {
								label: 'Vendor Code Prefix',
								required: false,
								maxLength: 10,
								readonly: config.isReadOnly,
							},
							validators: {
								validation: [FORMLY_FIELD_VALIDATORS.lettersOnly],
							},
						},
						{
							key: 'NextVendorCodeNumber',
							type: FORMLY_FIELD_TYPES.inputPositiveIntegers,
							className: 'col-md-3',
							props: {
								label: 'Next Vendor Code Number',
								required: false,
								maxLength: 9,
								readonly: config.isReadOnly,
							},
						},
					],
				},
			],
		},
	];
};
